<section class="pm-section">
  <p class="pm-heading">
    All <strong>plans</strong> include access to these <strong>core modules</strong>
  </p>

  <div class="pm-row">
    <div class="pm-tile" *ngFor="let m of coreModules">
      <div class="pm-tile-box">
        <img [src]="m.image" [alt]="m.name" class="pm-tile-icon" />
      </div>
      <p class="pm-tile-label">{{ m.name }}</p>
    </div>
  </div>
</section>
